import Serializable from './serializable';

export class Country extends Serializable {

	id: string;
	countryName: string;
	countryCode: string;
	name: {} = {};
}
